module.exports = __webpack_public_path__ + "img/75699.d2e2ae2a.svg";